import { fromJS } from 'immutable'
import {
  setPmTerm,
  setPmTermProcessing,
  setPmTermError,
  GET_PM_TERM,
  GET_PM_TERMS,
} from './actions'
import {
  getPmTermData,
} from '..'

const log = console

async function getPmTermDataHandler ({ store, payload }) {
  const { config, auth } = store.getState()
  try {
    store.dispatch(setPmTermProcessing(payload.id, true))
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
      id: payload.id,
    }
    const data = await getPmTermData(options)
    store.dispatch(setPmTerm(
      fromJS(data),
    ))
  } catch (error) {
    log.error(error, 'Error getting term data.')
    store.dispatch(setPmTermError(
      error,
    ))
  }
}

async function getPmTermDataListHandler ({ store, payload }) {
  payload.ids.forEach((id) => {
    getPmTermDataHandler({ store, payload: { id } })
  })
}

export default (store) => (next) => (action) => {
  const { type, payload } = action
  switch (type) {
    case GET_PM_TERM:
      getPmTermDataHandler({ store, payload })
      break
    case GET_PM_TERMS:
      getPmTermDataListHandler({ store, payload })
      break
    default:
      break
  }
  next(action)
}
